export default __webpack_public_path__ + "static/media/students-blue.06cbc2d8.svg";